import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BwMaterialProvider } from "@bw/material";
import { AuthProvider } from "@bw/shared/components";
import type { ReactNode } from "react";
import { PlatformAuthoritySessionBoundary } from "./PlatformAuthoritySessionBoundary";
import { PlatformErrorBoundary } from "./PlatformErrorBoundary";
import { createPlatformTheme } from "./theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60,
      retry: 1,
    },
  },
});

const platformTheme = createPlatformTheme();

export function Providers({ children }: { children: ReactNode }) {
  return (
    <BwMaterialProvider
      theme={platformTheme}
      defaultMode="light"
      storageManager={null}
    >
      <PlatformErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <PlatformAuthoritySessionBoundary>
              {children}
            </PlatformAuthoritySessionBoundary>
          </AuthProvider>
        </QueryClientProvider>
      </PlatformErrorBoundary>
    </BwMaterialProvider>
  );
}
